import { TcProcessEvent } from '../types/tuitionContinuity';

export class TuitionForbiddenEvent<T> extends CustomEvent<T> {
  constructor() {
    super(TcProcessEvent.TC_PROCESS_UNAUTHORIZED);
  }
}
